import script from "./WithEmptyState.vue?vue&type=script&setup=true&lang=js"
export * from "./WithEmptyState.vue?vue&type=script&setup=true&lang=js"

export default script